// randomly generates a number between the range of low and high
function getRandom(low = 1, high = 10) {
	let randomNumber;
	// calculate random number
    randomNumber = Math.floor(Math.random() * (high - low)) + low;
	// return random number
	return randomNumber;
}

function addKey(functionToCall, myKeyCode = 13) {
    // wire up event listener
    document.addEventListener("keydown", (e) => {
        // is the key released the provided key? Check keyCode via Event object
        if (e.keyCode === myKeyCode) {
            // pressing the enter key will force some browsers to refresh
            // this command stops the event from going further
            e.preventDefault();
            // call provided callback to do everything else that needs to be done
            functionToCall();
            // this also helps the event from propagating in some browsers
            return false;
        }
    });
}

class CookieManager {

    setupCookie(name, value, days) {
        // construct date object - will be today's date by default
        let date = new Date();
        // set time to be today plus how many days specified
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        // concatenate the expires name/value pair with expiry date converted to GMT 
        let expires = "expires=" + date.toGMTString();
        // assemble cookie
        document.cookie = name + "=" + value + ";" + expires + ";";
    }
    
    retrieveCookie(name) {
        // return undefined if no cookie stored
        if (document.cookie === "") return undefined;
        // value to be returned is undefined by default
        let value;
        // put cookie name/value pairs into an array split on the ; delimiter (since there could be multiple cookies in the file)
        let cookieArray = document.cookie.split(";");
        // remove blank spaces from all elements of cookieArray
        cookieArray = cookieArray.map(cookie => cookie.trim());
        // find cookie with name and set value
        cookieArray.forEach(cookie => {
            if (cookie.split("=")[0] == name) {
                value = cookie.split("=")[1];
            }    
        });
        return value;
    }  
    
}

function getXMLData(retrieveScript, success, failure) {
    // send out AJAX request
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.addEventListener("load", (e) => {
        // has the response been received successfully?
        if (xmlhttp.status == 200) {
            // data retrieved - call success method and pass along XML object response
            success(xmlhttp.responseXML);
        } else {
            failure();
        }
    });
    xmlhttp.addEventListener("error", (e) => {
        failure();
    });
    xmlhttp.open("GET", retrieveScript, true);
    xmlhttp.send();
}

// function getJSONData(retrieveScript, success, failure) {
//     // send out AJAX request
//     let xmlhttp = new XMLHttpRequest();
//     xmlhttp.addEventListener("load", (e) => {
//         // has the response been received successfully?
//         if (xmlhttp.status == 200) {
//             // data retrieved - call success method and pass along XML object response
//             success(xmlhttp.responseText);
//         } else {
//             failure();
//         }
//     });
//     xmlhttp.addEventListener("error", (e) => {
//         failure();
//     });
//     xmlhttp.open("GET", retrieveScript, true);
//     xmlhttp.send();
// }

// rebuilding getJSONData using fetch approach
// function getJSONData(retrieveScript, success, failure) {
//     fetch(retrieveScript)
//         .then(function(response){
//             // console.log(response);
//             return response.json();
//         })
//         .then(function(data){
//             success(data);
//         })
//         .catch(function(err){
//             failure();
//         });
// }

// rebuilding with arrowFunctions
function getJSONData(retrieveScript, success, failure) {
    fetch(retrieveScript)
        .then(response => response.json())
        .then(data => success(data))
        .catch(err => failure());
}

function sendJSONData(sendScript, jsonString, success, failure) {
    // send out AJAX request
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.addEventListener("load", (e) => {
        // has the response been received successfully?
        if (xmlhttp.status == 200) {
            // data retrieved - call success method and pass along XML object response
            success(xmlhttp.responseText);
        } else {
            failure();
        }
    });
    xmlhttp.addEventListener("error", (e) => {
        failure();
    });
    xmlhttp.open("POST", sendScript, true);
    xmlhttp.send(jsonString);
}

export {getXMLData, CookieManager};